import { VDBText } from "@components/atoms";
import Routes from "@navigations/Routes";
import { setLoginModalType } from "@redux/slices/appStateSlice";
import React from "react";
import { useDispatch } from "react-redux";
import { ResetHereToastMessageProps } from "./types";
import useScreenOptionsHooks from "../../../hooks/useScreenOptionsHooks";

export const ResetHereToastMessage = ({
  message,
  navigation,
  userInfo,
  username,
  t,
}: ResetHereToastMessageProps) => {
  const dispatch = useDispatch();
  const { typography, theme } = useScreenOptionsHooks();

  const messageParts = message.toString().split("{{reset_here}}");

  const handleResetPress = () => {
    if (userInfo.isGuest) {
      navigation.navigate(Routes.GlobalNavigator, {
        headerShown: "true",
        screen: Routes.ForgotPassword,
        params: { username },
      });
      dispatch(setLoginModalType("none"));
    } else {
      navigation.navigate(Routes.ForgotPassword, { username });
    }
  };

  return (
    <VDBText color={theme["core-06"]} type={typography["Minor-R"]}>
      {messageParts[0]}
      <VDBText
        color={theme["link-static"]}
        type={typography["Minor-R"]}
        onPress={handleResetPress}
      >
        {t("login.resetHere.toastMessage.text")}
      </VDBText>
      {messageParts[1]}
    </VDBText>
  );
};
